import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const LinkButton = ({
  href,
  children,
  className,
  disabled,
  isPrimaryStyle = false,
}) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <a
        className={classNames(
          isPrimaryStyle ? 'primary-button' : 'general-button',
          className,
          {
            disabled,
          },
        )}
        href={href}
        rel="noreferrer noopener"
        target="_blank"
      >
        {children}
      </a>
      <style jsx>{`
        .general-button {
          border-radius: 6px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          margin-bottom: 4px;
          min-height: 42px;
          padding: 4px 16px;
          text-transform: ${theme.text.cta.button};
          white-space: nowrap;
          background-color: ${theme.colors.buttonsecondary};
          color: ${theme.colors.buttontext};
          border: none;
          border-bottom: 3px solid ${theme.colors.buttonsecondaryhover};
        }
        .general-button:hover {
          background-color: ${theme.colors.buttonsecondaryhover};
          border-bottom: 3px solid #520031;
          text-decoration: none;
        }
        .general-button.full-width {
          width: 100%;
        }
        .general-button.margin {
          margin-bottom: 10px;
        }
        .general-button.disabled {
          opacity: 0.4;
          pointer-events: none;
        }
        .primary-button {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: ${theme.colors.dealviewbutton};
          text-align: center;
          color: #ffffff;
          font-weight: bold;
          font-size: 18px;
          border-radius: 60px;
          border: none;
          text-decoration: none;
          text-transform: uppercase;
          outline: none;
          min-width: 100px;
          min-height: 40px;
          padding: 7px 20px;
        }
        .primary-button.size-largest-mobile-only {
          font-size: 28px;
          min-height: 55px;
        }
        .primary-button.size-largest {
          font-size: 28px;
          min-height: 55px;
        }
        .primary-button.size-medium {
          font-size: 16px;
          line-height: 16px;
          min-height: 40px;
          padding: 6px 20px;
        }
        .primary-button.size-small {
          font-size: 12px;
          min-height: 25px;
          padding: 6px 12px;
        }
        @media only screen and (max-width: ${theme.breakpoints.smUp}) {
          .primary-button.size-small {
            font-size: 10px;
            min-height: 25px;
            padding: 6px 12px;
          }
        }
        .primary-button.size-smallest {
          font-size: 12px;
          min-height: 25px;
          padding: 6px 12px;
        }
        @media only screen and (max-width: ${theme.breakpoints.smUp}) {
          .primary-button.size-smallest {
            font-size: 16px;
            min-height: 38px;
            min-width: 306px;
            padding: 6px 12px;
          }
        }
        .primary-button.size-smaller {
          font-size: 11px;
          min-height: 18px;
          min-width: unset;
          padding: 3px 11px;
          position: relative;
        }
        @media only screen and (min-width: ${theme.breakpoints.smUp}) {
          .primary-button.size-largest-mobile-only {
            font-size: 20px;
            min-height: 40px;
          }
        }
        @media only screen and (min-width: ${theme.breakpoints.smUp}) {
          .primary-button.size-largest {
            font-size: 35px;
            min-height: 40px;
          }
        }
        .primary-button.size-xlarger {
          font-size: 22px;
          min-height: 40px;
        }
        @media only screen and (max-width: ${theme.breakpoints.smUp}) {
          .primary-button.size-xlarger {
            font-size: 16px;
            min-height: 42px;
            min-width: 350px;
          }
        }
        .primary-button.size-larger {
          font-size: 24px;
          min-height: 55px;
        }
        @media only screen and (min-width: ${theme.breakpoints.smUp}) {
          .primary-button.size-larger {
            min-height: 40px;
          }
        }
        .primary-button.size-large {
          font-size: 20px;
          min-height: 55px;
        }
        @media only screen and (min-width: ${theme.breakpoints.smUp}) {
          .primary-button.size-large {
            min-height: 40px;
          }
        }
        .primary-button.size-xlarge {
          font-size: 25px;
          min-height: 40px;
        }
      `}</style>
    </>
  );
};

LinkButton.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  isPrimaryStyle: PropTypes.bool,
};

export default LinkButton;
